import { render, staticRenderFns } from "./AddToCall.vue?vue&type=template&id=0146f42f&scoped=true&"
import script from "./AddToCall.js?vue&type=script&lang=js&"
export * from "./AddToCall.js?vue&type=script&lang=js&"
import style0 from "../../Auth/AuthModal/AuthModal.scss?vue&type=style&index=0&id=0146f42f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0146f42f",
  null
  
)

export default component.exports